'use client'

import { useEffect, useState } from 'react'

import { useTranslation } from '@/hooks/client/use-translation'

let renderErrorThrown = false
let effectErrorThrown = false

export interface TestErrorClientProps {
  editableProps?: Record<string, unknown>
}

export const TestErrorClient = ({ editableProps }: TestErrorClientProps) => {
  const { t } = useTranslation()
  const [renderError, setRenderError] = useState(false)
  const [effectError, setEffectError] = useState(false)

  if (renderError && !renderErrorThrown) {
    renderErrorThrown = true
    throw new Error('render error')
  }

  useEffect(() => {
    renderErrorThrown = false
    effectErrorThrown = false
  }, [])

  useEffect(() => {
    if (effectError && !effectErrorThrown) {
      effectErrorThrown = true
      throw new Error('effect error')
    }
  }, [effectError])

  const makeError = () => {
    throw new Error('event handler error')
  }

  const buttonClass = 'bg-navy w-[200px] cursor-pointer rounded-lg border p-2 text-white'

  return (
    <div {...editableProps} className="flex flex-wrap gap-3">
      <button data-tracking="ignore" className={buttonClass} type="button" onClick={makeError}>
        {t('testError.eventHandler', 'Event Handler Error')}
      </button>
      <button data-tracking="ignore" className={buttonClass} type="button" onClick={() => setRenderError(true)}>
        {t('testError.render', 'Render Error')}
      </button>
      <button data-tracking="ignore" className={buttonClass} type="button" onClick={() => setEffectError(true)}>
        {t('testError.effect', 'Effect Error')}
      </button>
    </div>
  )
}
